// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".coin-balance[data-v-ce8d737c] {\n  display: flex;\n  margin: var(--magic-space--small, 8px) 0 calc(var(--magic-space, 16px) + var(--magic-space--small, 8px));\n  padding: var(--magic-space, 16px);\n  border-radius: var(--magic-border-radius, 4px);\n  width: 100%;\n}\n@media (min-width: 1024px) {\n  .coin-balance[data-v-ce8d737c] {\n    margin: calc(var(--magic-space, 16px) + var(--magic-space--small, 8px)) 0;\n    width: var(--magic-element-default-width, 288px);\n  }\n}", ""]);
// Exports
module.exports = exports;
